export function enumNames() {

    return (input: any) => {
        if (!input) {
            return [""];
        }

        return Object.keys(input).filter(([key]) => isNaN(Number(key)));
    }
}
